/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_SuccessInputs */

const en_contact_form_success = /** @type {(inputs: Contact_Form_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message sent successfully!`)
};

const lv_contact_form_success = /** @type {(inputs: Contact_Form_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziņa veiksmīgi nosūtīta!`)
};

/**
* | output |
* | --- |
* | "Message sent successfully!" |
*
* @param {Contact_Form_SuccessInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const contact_form_success = /** @type {((inputs?: Contact_Form_SuccessInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_SuccessInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_contact_form_success(inputs)
	return en_contact_form_success(inputs)
});